import React from "react";

export default function CheckboxOption({ option, optionsUtility }) {
  const handleChange = (changeEvent) => {
    const valueLabel = changeEvent.target.getAttribute("data-value-label");
    const optionName = changeEvent.target.getAttribute("data-option-name");
    const valueSku = changeEvent.target.getAttribute("data-value-sku");

    optionsUtility.changeOptionToLabel(optionName, valueLabel, valueSku);
  };

  return (
    <div className="optionValue">
      <>
        {option.values.map((value) => {
          return (
            <label
              key={value.label}
              className={value.selected ? "selected" : ""}
            >
              <input
                required=""
                type="radio"
                value={value.price}
                checked={value.selected}
                onChange={handleChange}
                data-option-name={option.name}
                data-value-label={value.label}
                data-value-sku={value.sku}
              />
              {value.label}
            </label>
          );
        })}
      </>
    </div>
  );
}
